module.exports = __webpack_public_path__ + "static/media/21ECLAC49.218e6b27.jpg";